<template>
  <div class="gameList">
    <GameListItem
      v-for="(gameData, index) in gameDatas" 
      v-bind:gameData="gameData" 
      v-bind:key="index"></GameListItem>
  </div>
</template>

<script>
import GameListItem from './GameListItem'

export default {
  name: 'GameListControll',
  components: {
    GameListItem
  },
  props: ['gameDatas'],
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/*スマートフォン・タブレット向けレイアウト*/
.gameList{
  width: 100%;
  height:100%;
  margin: 0;
  display: flex;
  flex-wrap: wrap;
  justify-content:space-evenly;
  position: absolute;
  left:0;
  overflow-y: auto;
}

/*Safari対策*/
@media screen and (max-width:599px){
  .gameList:last-child{
    margin-bottom: 65px;
  }
}

/*PC向けレイアウト*/
@media screen and (min-width:1280px){
  .gameList{
    width: 100%;
    height: calc(100% - 30px);
    padding-top: 15px;
    padding-bottom: 15px;
  }
}
</style>

